export const isActionKey = (key: string) => {
    return key === 'Enter' || key === ' ';
};

export const AN_ACTIVE_KEY = 'Enter';
